import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-site-header',
    imports: [RouterLink],
    templateUrl: './site-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './site-header.component.scss'
})
export class SiteHeaderComponent {

}
